export function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}
export function joinAndCapitalize(arr) {
    if (!arr) {
        return "";
    }
    arr = arr.map((s) => {
        return capitalizeFirstLetter(s);
    });
    return arr.join(", ");
}
